import { render, staticRenderFns } from "./InviteModel.vue?vue&type=template&id=5222c093&scoped=true"
import script from "./InviteModel.vue?vue&type=script&lang=js"
export * from "./InviteModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5222c093",
  null
  
)

export default component.exports